import { Delete, Edit } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { EEntityType, entityTypeToLink } from '@sharedInterfaces/globalEnums';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import CardBox from '@src/App/Components/Cards/CardBox/CardBox';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import type Competence from '@src/Objects/Competence';
import type { AppState } from '@store/store';
import React from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './CompetenceCard.css';
import { CompetenceDialog } from '@src/App/Components/Dialogs/CompetenceDialog/CompetenceDialog';
import ExpandableText from '@src/App/Components/General/ExpandableText/ExpandableText';
import FormatedTextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/FormatedTextInput/FormatedTextInput';

interface CompetenceCardProps {
    competence: Competence;
    selected?: boolean;
    onSelectChange?: (state: boolean) => void;
}

/**
 * CompetenceCard Component
 *
 * @param {CompetenceCardProps} props - The props object containing the data for the CompetenceCard
 * @returns {JSX.Element} The rendered CompetenceCard component
 */
function CompetenceCard(props: CompetenceCardProps) {
    const { openDialog } = useDialog();
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).competence;
    const navigate = useNavigate();
    const competence = props.competence;
    return (
        <CardBox
            menu={
                <div>
                    <MenuItem
                        onClick={() => {
                            return openDialog(<CompetenceDialog id={'CompetenceDialog'} competence={competence} />);
                        }}
                    >
                        <ListItemIcon>
                            <Edit />
                        </ListItemIcon>
                        <ListItemText>{langStrings.edit}</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            competence.delete();
                        }}
                    >
                        <ListItemIcon>
                            <Delete />
                        </ListItemIcon>
                        <ListItemText>{langStrings.delete}</ListItemText>
                    </MenuItem>
                </div>
            }
            onSelectChange={props.onSelectChange}
            selected={props.selected}
            title={competence.title}
            className={'competenceCard'}
            onClick={() => {
                // return;
                navigate(entityTypeToLink(competence.id, EEntityType.COMPETENCE));
            }}
        >
            {/* <div>{langStrings.skillCoverage}: {competence.skillCoverage}% </div> */}
            <ExpandableText>
                <>
                    {langStrings.description + ': '}
                    <FormatedTextInput value={competence.description} readonly={true} />
                </>
            </ExpandableText>
        </CardBox>
    );
}

export default CompetenceCard;
